<template>
  <v-app>
    <v-app-bar dense flat max-height="48">
      <v-container class="py-0 fill-height" fluid>
        <v-text-field
          v-if="!videoId"
          placeholder="https://www.youtube.com/watch?v=ABCDEF12345"
          dense
          outlined
          hide-details
          rounded
          @change="videoUrlChange">
        </v-text-field>
        <a
          v-if="videoId"
          :href="`https://youtu.be/${videoId}`"
          target="_blank"
          class="font-weight-bold text-decoration-none">
          {{videoTitle}}
        </a>
        <v-spacer></v-spacer>
        <div class="text-right">
          YouTube Timestamper
        </div>
      </v-container>
    </v-app-bar>
    <v-main>
      <router-view/>
    </v-main>
  </v-app>
</template>

<script>
import axios from 'axios';

const YOUTUBE_REGEX = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;

export default {
  data: () => ({
    videoTitle: '',
  }),
  computed: {
    videoId() {
      return this.$store.state.videoId;
    },
  },
  methods: {
    async videoUrlChange(value) {
      this.$store.commit('videoError', null);
      if (!value) return;
      // Extract Video ID
      const videoId = this.extractVideoId(value);
      if (!videoId) {
        // Next tick because we use vuetify transitions
        // We set to null just above which will hide it, then next tick set value to fade in
        this.$nextTick(() => {
          this.$store.commit('videoError', 'Invalid YouTube link.');
        });
        return;
      }
      // Fetch video information from HoloDex
      const videoInfo = await this.getVideoInfo(videoId).catch(() => null);
      if (!videoInfo) {
        this.$nextTick(() => {
          this.$store.commit('videoError', 'Unable to get video information. The video must be supported by HoloDex.');
        });
        return;
      }
      // Store video information
      this.videoTitle = videoInfo.title;
      this.$store.commit('videoId', videoId);
      this.$store.commit('videoStart', videoInfo.start_actual);
    },
    extractVideoId(url) {
      const match = url.match(YOUTUBE_REGEX);
      return (match && match[7].length === 11) ? match[7] : false;
    },
    async getVideoInfo(videoId) {
      const info = await axios.get(`https://holodex.net/api/v2/videos/${videoId}`);
      return info.data;
    },
  },
};
</script>
